class componentTimer extends HTMLElement {

    constructor() {

        super();

        this.initCounter();
    }

    /**
	 * Init counter
     * 
     * @return {undefined}
	 */

     initCounter() {
        let counter = document.querySelectorAll('[data-counter]');
        let collectionCounter = document.querySelector('.collection__timer-wrapper');

        counter.forEach(timer => {
            // Set the date we're counting down to
            let countDownDate = timer.dataset.date.trim();
            countDownDate = countDownDate.replace(/-/g, "/");
            countDownDate = Date.parse(countDownDate);
            // adding up the hours to end at the end of the day
            countDownDate = countDownDate + 86340000;

    
            // Update the count down every 1 second
            setInterval(this.countdown , 1000, countDownDate, timer); 

            if (collectionCounter) {
            
               this.scrollSticky();
      
            }
        });
	}


    /**
	 * Init countdown
     *   
     * @param {countDownDate} countDownDate The date we're counting down to.
     * @param {timer} timer A timer object.
     * @return {undefined}
	 */

    countdown(countDownDate, timer) {
        // Get today's date and time
        let now = new Date().getTime();

        // Find the distance between now and the count down date
        let distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
        let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();

        days = days.padStart(2, '0');
        hours = hours.padStart(2, '0');
        minutes = minutes.padStart(2, '0');
        seconds = seconds.padStart(2, '0');
        
       
        let dateString = timer.dataset.date.trim();

        if (dateString && !dateString.includes('T')) {
            dateString = dateString.replace(' ', 'T');
        }

        let date = new Date(dateString);

        let daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let dayOfWeek = daysOfWeek[date.getDay()];

        if (document.body.classList.contains('template-collection')) {
            // Display the result in the element
            timer.innerHTML = `<div class="collection__timer-text-wrapper">Ends <div class="collection__timer-wrapper--text">${dayOfWeek}</div></div>
            <div class="collection__timer-text-wrapper">${days} <div class="collection__timer-wrapper--text">day(s)</div></div>
            <div class="collection__timer-text-wrapper">${hours} <div class="collection__timer-wrapper--text">hrs</div></div>
            <div class="collection__timer-text-wrapper">${minutes} <div class="collection__timer-wrapper--text">min</div></div>
            <div class="collection__timer-text-wrapper">${seconds} <div class="collection__timer-wrapper--text">sec</div></div>`;
        } else if (days > 0)  {
            // Display the result in the element
            let numbers = days + "d " + hours + ":" + minutes + ":" +  seconds ;

            numbers =  '<span class="timer__numbers">'+ numbers +'</span>';

            if(timer.dataset.counterStart) {   
                timer.innerHTML = "Starts " + numbers;

            } else {
                timer.innerHTML = "Ends " + numbers;
            }

        } else {
            // Display the result in the element
            let numbers = hours + ":" + minutes + ":" +  seconds ;

            numbers =  '<span class="timer__numbers">'+ numbers +'</span>';

            if(timer.dataset.counterStart) {   
                timer.innerHTML = "Starts " + numbers;

            } else {
                timer.innerHTML = "Ends " + numbers;
            }
        }


        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval();
            timer.innerHTML = timer.dataset.mensagemTimerOver;
        }
    }

    /**
	 * Init sticky on scroll
     *   
     * @return {undefined}
	 */

    scrollSticky() {
        let scrollPosition = window.scrollY || document.documentElement.scrollTop;
        let container = document.querySelector('.collection__timer-container');

        scrollPosition = window.scrollY || document.documentElement.scrollTop;

        const isDesktop = window.innerWidth >= 1024;

        if (scrollPosition > 30) {
            setTimeout(() => {
                container.classList.add("sticky");
                document.body.classList.add("timer-sticky");
            }, isDesktop ? 200 : 0);
        } else  {
            setTimeout(() => {
                container.classList.remove("sticky");
                document.body.classList.remove("timer-sticky");
            }, isDesktop ? 200 : 0);
        }
        
        window.addEventListener('scroll', () => {
            scrollPosition = window.scrollY || document.documentElement.scrollTop;
        
            if (scrollPosition > 30) {
                setTimeout(() => {
                    container.classList.add("sticky");
                    document.body.classList.add("timer-sticky");
                }, isDesktop ? 200 : 0);
            } else {
                setTimeout(() => {
                    container.classList.remove("sticky");
                    document.body.classList.remove("timer-sticky");
                }, isDesktop ? 200 : 0);
            }
        });
    }
	
}

customElements.define('component-timer', componentTimer);

